export const CLEARING_DOC_API = (communityId: string) =>
  `v1/community/${communityId}/clearing-documents`;
